import Text, { TextProps } from "../elements/Text";
import prefillProps from "../util/prefillProps";

export const Description = prefillProps<TextProps>(Text, {
  fs: -1,
  c: ["grey", 6],
  lh: "normal"
});

export const FormLabel = prefillProps<TextProps>(Text, {
  fs: 0,
  c: ["grey", 8],
  lh: "condensed"
});

export const pageTitleProps: TextProps = {
  fs: 3,
  c: ["grey", 9],
  fw: "heavy",
  lh: "normal"
};

export const PageTitle = prefillProps<TextProps>(Text, pageTitleProps as any);

export const pageSubtitleProps: TextProps = {
  fs: -1,
  c: ["grey", 5],
  fw: "normal",
  lh: "normal",
  uppercase: true
};

export const PageSubtitle = prefillProps<TextProps>(Text, pageSubtitleProps);

export const Header = prefillProps<TextProps>(Text, {
  fs: 3,
  c: ["grey", 9],
  fw: "bold",
  lh: "normal"
});

export const LearnChapter = prefillProps<TextProps>(Text, {
  fs: 3,
  c: ["grey", 9],
  fw: "bold",
  lh: "normal",
  f: "Merriweather"
});

export const LearnSection = prefillProps<TextProps>(Text, {
  fs: 2,
  c: ["grey", 9],
  fw: "bold",
  lh: "normal",
  f: "Merriweather"
});

export const LearnStructureMeta = prefillProps<TextProps>(Text, {
  fs: -2,
  c: ["grey", 6],
  fw: "normal",
  lh: "normal",
  f: "Merriweather"
});

export const LearnPageTitle = prefillProps<TextProps>(Text, {
  fs: 3,
  c: ["grey", 9],
  fw: "bold",
  lh: "normal",
  f: "Merriweather"
});

export const LearnPageSubtitle = prefillProps<TextProps>(Text, {
  fs: -1,
  c: ["grey", 5],
  fw: "normal",
  lh: "normal",
  f: "Merriweather"
});

export const ContentText = prefillProps<TextProps>(Text, {
  fs: 0,
  c: ["grey", 9],
  fw: "normal",
  lh: "wide",
  f: "Merriweather"
});

export const ContentTitle = prefillProps<TextProps>(Text, {
  fs: 1,
  c: ["grey", 9],
  fw: "heavy",
  lh: "normal",
  f: "Lato"
});

export const OverlayTitle = prefillProps<TextProps>(Text, {
  fs: 3,
  c: ["grey", 9],
  fw: "heavy",
  lh: "normal"
});

export const OverlayDescription = prefillProps<TextProps>(Text, {
  fs: -1,
  c: ["grey", 6],
  lh: "normal"
});
